import script from "./EmailAniversario.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailAniversario.vue?vue&type=script&setup=true&lang=js"

import "./EmailAniversario.vue?vue&type=style&index=0&id=6c955248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c955248"]])

export default __exports__